export const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : process.env.NODE_ENV === 'development';
//# sourceMappingURL=is-dev.js.map